<template>
  <footer class="footer">
    <div class="content">
      <div class="left">
        <div class="logo">
          <img src="@/assets/images/logo.png" class="icon">
          DineroAgil
        </div>
        <img src="@/assets/images/googleDownload.png" class="google" @click="toDownload">
        <div class="item">
          <img src="@/assets/images/iconPhone.png" class="icon">
          Línea directa de quejas： 7352448835
        </div>
        <div class="item">
          <img src="@/assets/images/whatsapp.png" class="icon">
          WhatsApp: +527352448835
        </div>
        <div class="item">
          <img src="@/assets/images/iconEmail.png" class="icon">
          support@felielefante.com
        </div>
      </div>
      <div class="right">
        <div class="tab">
          <div class="label">Horario de servicio</div>
          <div class="item">
            <img src="@/assets/images/iconClock.png" class="icon">
            Lunes a sábado de 9:00 a 17:30
          </div>
        </div>
        <div class="tab">
          <div class="label">Centro de ayuda</div>
          <div class="item pointer" @click="jump('/questions')">
            <img src="@/assets/images/iconHelp.png" class="icon">
            Preguntas frecuentes
          </div>
        </div>
        <div class="tab">
          <div class="label">Sociedad</div>
          <div class="item pointer" @click="jump('/joinUs')">
            <img src="@/assets/images/iconRecruitment.png" class="icon">
            PAYEQUIPGLOBAL S.A. DE C.V.
          </div>
          <div class="item">
            <img src="@/assets/images/iconAddress.png" class="icon">
            Calle Sebastián de Aparicio 74, MINAS DE CRISTO, ALVARO OBREGON, CDMX 01410
          </div>
        </div>
      </div>
    </div>
    <div class="interest">
      Si solicitas un préstamo de 10,000 pesos con un plazo de 91 días, considerando una tasa anual del 35%; Interés total: 10,000 → (35% / 365) × 91 = 872.60 pesos; Monto total a pagar: 10,872.60 pesos；Este ejemplo es únicamente ilustrativo y no garantiza la aprobación de un monto o tasa específica. Las condiciones finales dependerán de la información proporcionada y del resultado de la evaluación crediticia.
    </div>
    <div class="reserve">
      Todos los derechos reservados © 2023 DineroAgil
    </div>
  </footer>
</template>

<script>

import { queryAppInfo } from '@/api';

export default {
  name: "GlobalFooter",
  data() {
    return {
      acitve: 1,
    };
  },
  mounted() {
    queryAppInfo({
      do: {
        appCode: 'NuevaDineroAgil',
      }
    }).then(res => {
      if (res.statusCode) {
        if (res?.response?.appMarketUrl) {
          this.$store.commit('setAppMarketUrl', res?.response?.appMarketUrl)
        }
      }
    })
  },
  methods: {
    jump(path) {
      if (this.$route.path === path) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        this.$router.push(path);
      }
    },
    toDownload() {
      this.$store.state.appMarketUrl && window.open(this.$store.state.appMarketUrl)
    }
  },
};
</script>

<style scoped lang="scss">
.footer{
  background-color: #6B75F1;
  padding: 64px 120px 0;
  .content{
    display: flex;
    justify-content: space-between;
    padding-bottom: 64px;
    .left{
      color: #fff;
      .logo{
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: 600;
        .icon{
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
      }
      .google{
        width: 121px;
        height: 50px;
        cursor: pointer;
        margin-top: 24px;
      }
      .item{
        display: flex;
        align-items: center;
        margin-top: 24px;
        font-size: 14px;
        .icon{
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }
    }
    .right{
      display: flex;
      color: #fff;
      .tab{
        margin-left: 48px;
        &:first-child{
          margin-left: 0; 
        }
        .label{
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
        }
        .item{
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 20px;
          max-width: 400px;
          padding-top: 16px;
          .icon{
            width: 24px;
            height: 24px;
            margin-right: 8px;;
          }
          &.pointer{
            cursor: pointer;
          }
        }
      }
    }
  }
  .interest {
    border-top: 1px solid rgba(255, 255, 255, 0.40);
    padding: 24px 0px 20px;
    color: #FFF;
    font-family: MiSans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .reserve{
    color: #fff;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    padding-top: 18px;
    padding-bottom: 32px;
    border-top: 1px solid #fff;
  }
}
</style>
